import { Link } from 'react-router-dom'
import { AlertCircle } from 'lucide-react'
import { Button } from '@/components/ui/button'

const NotFoundPage = () => {
  return (
    <div className='flex min-h-screen flex-col items-center justify-center px-4 py-10 sm:px-6 lg:px-8'>
      <div className='w-full max-w-md text-center'>
        <div className='mb-8 flex justify-center'>
          <div className='flex h-24 w-24 items-center justify-center rounded-full bg-destructive/10'>
            <AlertCircle className='h-12 w-12 text-destructive' />
          </div>
        </div>

        <h1 className='mb-2 text-6xl font-bold'>404</h1>
        <h2 className='mb-4 text-2xl font-semibold'>Page Not Found</h2>
        <p className='text-muted-foreground mb-8'>
          Sorry, we couldn't find the page you're looking for. It might have been moved or doesn't exist.
        </p>

        <div className='flex flex-col gap-3 sm:flex-row sm:justify-center'>
          <Button asChild>
            <Link to='/overview'>Go to Dashboard</Link>
          </Button>
          <Button variant='outline' asChild>
            <Link to='/auth/login'>Back to Login</Link>
          </Button>
        </div>
      </div>
    </div>
  )
}

export default NotFoundPage

